<template>
  <div>
    <div v-wechat-title="'新春开局，胜天半子'"></div>
    <div class="pc-page-content">
      <div class="logo"></div>
      <div class="slogan"></div>
      <div class="qrcode-box"></div>
    </div>
  </div>
</template>
<script>
import { getTimeStamp } from "@/utils/utils";
import { mapActions } from "vuex";

export default {
  components: {},
  props: {
    logger: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      enterLink: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 分享
      this.enterLink =
        "https://h5.qingcigame.com/snail/springFestival/anniversary";
      this.monitoringEquipment(this.enterLink);
      this.isSetShare(this.enterLink);
    });
  },
  computed: {},
  watch: {
    logger: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.logger.sum("中秋_PC端");
        }
      },
    },
  },
  methods: {
    monitoringEquipment(linkUrl) {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = `${linkUrl}${getTimeStamp()}`;
      }
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: "【最强蜗牛】蜗也要胜天半子！",
        imgUrl:
          "https://download4.qcplay.com/qcgame-api/mDG0FvkV2xtEH4cfyEIt8MMcWF6CxRo6IdrDiHzx.png",
        desc: "组队闯天局，限定绿贵轻松到手，搜寻Beter前世“马必得”的秘密宝库，入队速戳！",
      });
    },
    ...mapActions(["setShare"]),
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/springFestival/pc/index.vue